import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ImpactAssessment, ImpactAssessmentAssessmentDetailsList } from 'src/app/core/models/impact-assessment/impact-assessment';
import { ImpactAssessmentDetailListModel } from 'src/app/core/models/impact-assessment/impact-assessment-detail-list-model';
import { FilterViewModel } from 'src/app/core/models/regulation';
import { SelfAssessmentDocumentModel } from 'src/app/core/models/self-assessment/self-assessment-document-model';
import { ImpactService } from 'src/app/core/services/impact/impact.service';
import { AlertDialogModel, ToastViewModel } from 'src/app/core/models/view-model';
import { DeleteDialogComponent } from '../../distributed-ui-components';
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { MatChipInputEvent } from '@angular/material/chips';
//import * as customBuild from './../../../../ckCustomeBuild/build/ckeditor';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-impact-assessment-template3',
  templateUrl: './impact-assessment-template3.component.html',
  styleUrls: ['./impact-assessment-template3.component.scss']
})
export class ImpactAssessmentTemplate3Component implements OnInit {
  private _impactAssessment!: ImpactAssessment;
  public get impactAssessment(): ImpactAssessment {
    return this._impactAssessment;
  }
  @Input() public set impactAssessment(v: ImpactAssessment) {
    this._impactAssessment = v;
    this.impactAssessmentChange.emit(this._impactAssessment);
  }
  @Output() impactAssessmentChange = new EventEmitter<ImpactAssessment>();

  // @Input() ruleType:Array<string> = []; 
  @Input() isIDetails: boolean = false;
  @Input() isIADetails3: boolean = false;
  @Input() isIADetails2: boolean = false;
  @Input() isIADetails1: boolean = false;
  @Input()
  iaDetailHistory!: ImpactAssessmentDetailListModel;
  @Input()
  impactAssessmentDocument!: Array<SelfAssessmentDocumentModel>;
  @Input() isADetailPermission: boolean = true;
  @Input() isIDPermission: boolean = false;
  @Input() isIDetailPermission: boolean = true;
  @Input() isImplementationLoader: boolean = false;
  @Input()
  filterType!: string;
  @Input()
  publicationDetails!: string;
  @Input()
  impactDetails!: string;
  @Input()
  implementationDetails!: string;
  @Input()
  actionsRequiredArray!: Array<string>;

  @Output("updateSectionLastEdited") updateSectionLastEdited: EventEmitter<any> = new EventEmitter();
  @Output("removeAssessorfunc") removeAssessorfunc: EventEmitter<any> = new EventEmitter();
  @Output("removeActionOwnerFunc") removeActionOwnerFunc: EventEmitter<any> = new EventEmitter();
  @Output("checkImplementationDetailRequiredFunc") checkImplementationDetailRequiredFunc: EventEmitter<any> = new EventEmitter();
  @Output("selectedAssessorEventfunc") selectedAssessorEventfunc: EventEmitter<any> = new EventEmitter();
  @Output("selectedActionOwnerEventFunc") selectedActionOwnerEventFunc: EventEmitter<any> = new EventEmitter();
  @Output("selectedImplementationOwnerEventFunc") selectedImplementationOwnerEventFunc: EventEmitter<any> = new EventEmitter();
  @Output("removeImplementationOwnerFunc") removeImplementationOwnerFunc: EventEmitter<any> = new EventEmitter();
  @Output("uploadEvidenceImplementationFunc") uploadEvidenceImplementationFunc: EventEmitter<any> = new EventEmitter();
  @Output("setProjectPreferenceFunc") setProjectPreferenceFunc: EventEmitter<any> = new EventEmitter();
  @Output("handleImplementationInputFunc") handleImplementationInputFunc: EventEmitter<FileList> = new EventEmitter();
  @Output("getFilteredDatafunc") getFilteredDatafunc: EventEmitter<getFilterOutput> = new EventEmitter<getFilterOutput>();
  @Output("openDeleteModelFunc") openDeleteModelFunc: EventEmitter<openDeleteModelOutput> = new EventEmitter<openDeleteModelOutput>();
  @Output("downloadDocumentFunc") downloadDocumentFunc: EventEmitter<downloadDocumentOutput> = new EventEmitter<downloadDocumentOutput>();
  @Input() assessmentStatus: Array<string> = [];
  @Input() assessorDD: string[] = [];
  @Input() actionOwnerDD: string[] = [];
  newActionOwnerDD: string[] = this.actionOwnerDD;
  @Input() searchedAssessor: FilterViewModel[] = [];
  @Input() searchedActionOwner: FilterViewModel[] = [];
  @Input() searchedImptOwner: FilterViewModel[] = [];
  @Input() searchAssessorCntrl: FormControl = new FormControl();
  @Input() searchActionOwnerCntrl: FormControl = new FormControl();
  @Input() searchImptOwnerCntrl: FormControl = new FormControl();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  selectable = true;
  removable = true;
  addOnBlur = true;
  alertDialogModel: AlertDialogModel;
  isDeleteAllTopic: boolean = false;
  toastModel!: ToastViewModel;
  isToastShow = false;
  getFilterOutput = {} as getFilterOutput
  openDeleteModelOutput = {} as openDeleteModelOutput
  downloadDocumentOutput = {} as downloadDocumentOutput
  @Input() imptOwnerDD: string[] = [];
  @Input() implementationStatus: Array<string> = [];
  @Input() implementationType: Array<string> = [];
  @ViewChild('imptOwnerAutocomplete')
  imptOwnerAutocomplete!: MatAutocomplete;
  @ViewChild('actionOwnerAutocomplete')
  actionOwnerAutocomplete!: MatAutocomplete;
  @ViewChild('assessorAutocomplete')
  assessorAutocomplete!: MatAutocomplete;
  multipleRowIncreament: number = 0;
  @ViewChild('ownerInput')
  ownerInput!: ElementRef<HTMLInputElement>;
  @ViewChild('trigautoOwner')
  trigautoOwner!: MatAutocompleteTrigger;

  @ViewChild('assessorInputTemp3')
  assessorInput!: ElementRef<HTMLInputElement>;
  @ViewChild('trigautoAssessorTemp3')
  trigautoAssessor!: MatAutocompleteTrigger;

  @ViewChild('imptOwnerInputTemp3')
  imptOwnerInput!: ElementRef<HTMLInputElement>;
  @ViewChild('trigautoImpOwnerTemp3')
  trigautoImpOwner!: MatAutocompleteTrigger;
  actionedRequiredText!: string;
  //public Editor = customBuild;


  constructor(public dialog: MatDialog, private impactService: ImpactService,public sanitizer: DomSanitizer) {
    this.alertDialogModel = new AlertDialogModel();
  }


  ngOnInit(): void {
    this.actionedRequiredText = "Please identify any actions that the compliance function will need to undertake in relation to this regulatory change. Even where compliance had no discernable actions relating to the implementation of the reg change, please use this field to capture actions such as; share details of the regulation with the relevant business area; help the business undertake a gap analysis against the proposed requirements; initiate compliance led project. ";
    if (!this.impactAssessment.assessmentDetailsList) {
      this.impactAssessment.assessmentDetailsList = [];
      this.impactAssessment.assessmentDetailsList.push({} as ImpactAssessmentAssessmentDetailsList);
      this.impactAssessment.assessmentDetailsList[0].actionsRequired = "";
      this.impactAssessment.assessmentDetailsList[0].actionStatus = "";
      this.impactAssessment.assessmentDetailsList[0].actionOwner = "";
      this.impactAssessment.assessmentDetailsList[0].nextActionDate = null;
    }
    this.impactService.impactAssessmentTemplate3ScrollNotifyObservable$.subscribe(res => {
      if (res.refresh) {
        this.scrollHandler();
      }
    })
    if(this.impactAssessment.assessmentDetails1 != '' && this.impactAssessment.assessmentDetails1 != null){
      let publication = this.impactAssessment.assessmentDetails1.split("</p>");
      this.publicationDetails = publication.length>0? publication[0]:"";
    }
    if(this.impactAssessment.assessmentDetails2 != '' && this.impactAssessment.assessmentDetails2 != null){
    let impact = this.impactAssessment.assessmentDetails2.split("</p>");
    this.impactDetails = impact.length>0? impact[0]:"";
    }
    if(this.impactAssessment.implementationDetails != '' && this.impactAssessment.implementationDetails != null){
    let implement = this.impactAssessment.implementationDetails.split("</p>");
    this.implementationDetails = implement.length>0? implement[0]:"";
    }
  }
  updateSectionLastEditedChild(filter:string) {
    this.updateSectionLastEdited.emit(filter);
  }
  removeAssessor(filter:any) {
    this.removeAssessorfunc.emit(filter);
  }
  removeActionOwner(filter:any) {
    this.removeActionOwnerFunc.emit(filter);
  }
  removeImplementationOwner(filter:any) {
    this.removeImplementationOwnerFunc.emit(filter);
  }
  checkImplementationDetailRequired(filter:any) {
    this.checkImplementationDetailRequiredFunc.emit(filter);
  }

  addImplementationOwner(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    //let rowInDropdownList = this.searchedImptOwner.filter(obj => obj.name === value);
    if (!this.imptOwnerAutocomplete.isOpen) {
      if ((value || '').trim()) {

        let sameValueRow = this.imptOwnerDD.filter(
          obj => obj === value);

        if (sameValueRow.length == 0) {
          (this.imptOwnerDD as string[]).push(value);
        }
      }

      if (input) {
        input.value = '';
      }
      this.searchImptOwnerCntrl.setValue(null);
      this.updateSectionLastEditedChild('ImplementationOwner');
    }
  }
 

  addAssessor(event: MatChipInputEvent):void{
    const value = event.value;
    if (!this.assessorAutocomplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.assessorDD.filter(
          obj => obj === value);
        if (sameValueRow.length == 0) {
          (this.assessorDD as string[]).push(value);
        }
      }
      event.chipInput!.clear();
      this.searchAssessorCntrl.setValue(null);
      this.updateSectionLastEditedChild('Assessor');
    }
  }
  

  addActionOwner(event: MatChipInputEvent, actionOwnerstring:string, row:number): void {
    const value = event.value;
    if (!this.actionOwnerAutocomplete.isOpen) {
      if ((value || '').trim()) {
        let ownerArray:string[] = [];
        if (actionOwnerstring) {
          ownerArray = actionOwnerstring.split(",");
        }
        let sameValueRow = ownerArray.filter(
          obj => obj === value);

        if (sameValueRow.length == 0) {
          ownerArray.push(value);
          this.impactAssessment.assessmentDetailsList[row].actionOwner = ownerArray.toString();
        }
      }
      else {
        if(actionOwnerstring != undefined){
          this.impactAssessment.assessmentDetailsList[row].actionOwner = actionOwnerstring.toString();
        }
      }

      event.chipInput!.clear();
      this.searchActionOwnerCntrl.setValue(null);
      this.updateSectionLastEditedChild('ActionOwner');
    }
  }
  selectedAssessorEvent(event:any) {
    this.selectedAssessorEventfunc.emit(event);
    this.assessorInput.nativeElement.value = '';
  }
  selectedActionOwnerEvent(event:any) {
    this.selectedActionOwnerEventFunc.emit(event);
  }
  selectedImplementationOwnerEvent(event:any) {
    this.selectedImplementationOwnerEventFunc.emit(event);
    this.imptOwnerInput.nativeElement.value = '';
  }
  uploadEvidenceImplementation() {
    this.uploadEvidenceImplementationFunc.emit();
  }
  setProjectPreference() {
    this.setProjectPreferenceFunc.emit();
  }
  handleImplementationInput(event: FileList) {
    this.handleImplementationInputFunc.emit(event);
  }
  getFilteredData(filter: string, event: any) {
    this.getFilterOutput.filter = filter;
    this.getFilterOutput.event = event;
    this.getFilteredDatafunc.emit(this.getFilterOutput);
  }
  openDeleteModel(id: number, fileType: string) {
    this.openDeleteModelOutput.id = id;
    this.openDeleteModelOutput.fileType = fileType;
    this.openDeleteModelFunc.emit(this.openDeleteModelOutput);
  }
  downloadDocument(id: number, fileName: string, extension: string, fileType: string) {
    this.downloadDocumentOutput.id = id;
    this.downloadDocumentOutput.fileName = fileName;
    this.downloadDocumentOutput.extension = extension;
    this.downloadDocumentOutput.fileType = fileType;
    this.downloadDocumentFunc.emit(this.downloadDocumentOutput);
  }
  addAssessmentDetails() {
    this.impactAssessment.assessmentDetailsList.push({} as ImpactAssessmentAssessmentDetailsList);
    this.impactAssessment.assessmentDetailsList[this.impactAssessment.assessmentDetailsList.length - 1].actionsRequired = "";
  }
  removeAssessmentDetails(index: number) {
    if (this.impactAssessment.assessmentDetailsList.length <= 1) {
      this.alertMessage('warning', 'Keeping atleast one action is required.');
    }
    else {
      this.openDeleteDialog(index);
    }
  }
  openDeleteDialog(index:number): void {
    this.alertDialogModel.HeadingText = 'Delete Item';
    this.alertDialogModel.BodyText = 'Are you sure you want to delete this?';
    this.alertDialogModel.ActionButtonText = 'Delete';
    this.alertDialogModel.IsAction = true;

    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: '450px',
      data: this.alertDialogModel
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Delete Item') {
        this.actionsRequiredArray = [];
        this.impactAssessment.assessmentDetailsList.splice(index, 1);
        this.actionsRequiredArray = this.impactAssessment.assessmentDetailsList.map(obj => obj.actionsRequired);
        this.isDeleteAllTopic = false;
      }
      else {
        this.isDeleteAllTopic = false;
      }
    });
  }
  alertMessage(type: string, message: string): void {
    if (type === 'success') {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
    }
    this.toastModel.Message = message;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3000);
  }
  getRandomInt() {
    this.multipleRowIncreament = this.multipleRowIncreament + 1
    return this.multipleRowIncreament;
  }
  selectedMultipleActionOwnerEvent(event: MatAutocompleteSelectedEvent, actionOwnerstring:string, row:number): void {
    let ownerArray:string[] = [];
    if (actionOwnerstring) {
      ownerArray = actionOwnerstring.split(",");
    }
    let sameValueRow = ownerArray.filter(
      obj => obj === event.option.viewValue);
    if (sameValueRow.length == 0) {
      ownerArray.push(event.option.viewValue);
      this.impactAssessment.assessmentDetailsList[row].actionOwner = ownerArray.toString();
      this.ownerInput.nativeElement.value = '';
      this.searchActionOwnerCntrl.setValue(null);
      this.searchActionOwnerCntrl.disable();
      this.searchActionOwnerCntrl.enable();
    }
    else {
      this.impactAssessment.assessmentDetailsList[row].actionOwner = actionOwnerstring.toString();
      this.ownerInput.nativeElement.value = '';
      this.searchActionOwnerCntrl.setValue(null);
      this.searchActionOwnerCntrl.disable();
      this.searchActionOwnerCntrl.enable();
    }

    //this.updateSectionLastEdited.emit('ActionOwner');
    //this.updateSectionLastEdited('ActionOwner');
  }
  removeMultipleActionOwner(status: string, row:number): void {
    let ownerArray:string[] = [];
    if (this.impactAssessment.assessmentDetailsList[row].actionOwner) {
      ownerArray = this.impactAssessment.assessmentDetailsList[row].actionOwner.split(",");
    }
    const index = (ownerArray as string[]).indexOf(status);

    if (index >= 0) {
      (ownerArray as string[]).splice(index, 1);
      this.impactAssessment.assessmentDetailsList[row].actionOwner = ownerArray.toString();
      //this.updateSectionLastEdited('ActionOwner');
    }
  }
  scrollHandler() {
    if (this.assessorAutocomplete?.isOpen) {
      this.trigautoAssessor.closePanel();
      this.assessorInput.nativeElement.blur();
    }
    if (this.imptOwnerAutocomplete?.isOpen) {
      this.trigautoImpOwner.closePanel();
      this.imptOwnerInput.nativeElement.blur();
    }
    if (this.actionOwnerAutocomplete?.isOpen) {
      this.trigautoOwner.closePanel();
      this.ownerInput.nativeElement.blur();
    }
  }
  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
export interface getFilterOutput {
  filter: string;
  event: any;
}
export interface openDeleteModelOutput {
  id: number;
  fileType: string;
}
export interface downloadDocumentOutput {
  id: number;
  fileName: string;
  extension: string;
  fileType: string;
}
